// extracted by mini-css-extract-plugin
export default {"wrapper":"Next_wrapper__9B3tX"};